<h2 mat-dialog-title>Quick Action</h2>
<mat-dialog-content class="mat-typography">
  <mat-chip-listbox class="pt-1">
    @for (type of productActionTypes; track $index) {
      <mat-chip-option
        [selectable]="productActionType !== type"
        [selected]="productActionType === type"
        (selectionChange)="setProductActionType(type)">
        {{ type }}
      </mat-chip-option>
    }
  </mat-chip-listbox>

  <div class="row">
    <div class="col-12 mb-3" [ngClass]="{ 'col-xl-6 col-lg-12': product && product.recentActions.length }">
      <div class="row mt-3">
        <app-dashboard-product-select />

        @if (product) {
          <div class="col-xxl-8 col-xl-12 col-lg-7 col-sm-12">
            <mat-form-field>
              <mat-label>Stock Entry</mat-label>
              <mat-select [formControl]="form.controls.stockItem">
                @if (!isTransfer) {
                  <mat-option [value]="null">---</mat-option>
                }

                @for (option of stockItems; track $index) {
                  <mat-option [value]="option" [disabled]="!form.canSelectStockItem(option)">
                    <div class="expanded-select-option">
                      <p>{{ getStockEntryDisplayValue(option) }}</p>
                      <small>
                        🛒 {{ option.purchasedAt | date: 'd MMM y' }} · 📅 {{ option.expiresAt | date: 'd MMM y' }} · 🗑️
                        {{ option.useBefore | date: 'd MMM y' }}
                      </small>
                    </div>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-xxl-4 col-xl-6 col-lg-5 col-md-6 col-sm-12">
            <mat-form-field>
              <mat-label>Amount</mat-label>
              <input matInput [formControl]="form.controls.amount" type="number" />
              <div matSuffix class="d-flex align-items-center">
                <span class="pe-5 pt-3">{{ form.quantityUnitName }}</span>
                <button (click)="form.setAmountToMax()" mat-icon-button matTooltip="Complete stock">
                  <mat-icon>inventory_2</mat-icon>
                </button>
              </div>

              <mat-hint>{{ form.amountHint }}</mat-hint>
            </mat-form-field>
          </div>

          @if (!isTransfer) {
            <div class="col-xxl-8 col-xl-6 col-lg-7 col-md-6 col-sm-12">
              <app-date-time-input [control]="form.controls.date" label="Date" />
            </div>
          }

          @if (isConsume) {
            <div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-sm-12">
              <app-boolean-input [control]="quickActionForms.consume.controls.spoiled" label="Spoiled" />
            </div>
          }

          @if (isTransfer) {
            <div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-sm-12">
              <app-entity-reference-input
                [control]="quickActionForms.transfer.controls.toLocation"
                label="To"
                [options]="quickActionForms.transfer.options.locations" />
            </div>
          }
        }
      </div>
    </div>

    @if (product && product.recentActions.length) {
      <div class="col-xl-6 col-lg-12">
        <div class="mt-3 ms-3 mb-3">
          <app-dashboard-recent-actions />
        </div>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="row">
    <div class="col text-end">
      @if (product) {
        <button
          mat-raised-button
          (click)="submit()"
          color="primary"
          [disabled]="
            form.formGroup.invalid || form.controls.stockEntry?.invalid || form.controls.amount.invalid || isSubmitting
          ">
          {{ productActionType }} {{ form.amount }}
          {{ form.quantityUnitName }}
        </button>
      }

      <app-open-form-validation-errors-dialog [formGroup]="form.formGroup" label="Quick Action" />

      <button mat-raised-button mat-dialog-close class="ms-2">Close</button>
    </div>
  </div>
</mat-dialog-actions>
